export const isQa = () => {
  return window.location.hostname.includes('www.wthubspot.com');
};
export const isAcceptanceTest = () => {
  const cookies = document.cookie.split(';');
  const acceptanceTestCookie = cookies.find(cookie => cookie.includes('hs_selenium='));
  return !!acceptanceTestCookie;
};